/* global localStorage */

import Vue from "vue";
import { auth } from "@/api";
import server from "@/backend";

export const EventBus = new Vue();

EventBus.$on("Unauthenticated", () => {
  logout();
  // this.$router.replace(this.$route.query.redirect || '/login')
});

EventBus.$on("notify", content => {
  const { type, message } = content;
  switch (type) {
    case "error":
      Vue.toasted.error(message);
      break;
    default:
      Vue.toasted.success(message);
  }
});

export function isValidJwt(jwt) {
  if (!jwt || jwt.split(".").length < 3) {
    return false;
  }
  const data = JSON.parse(atob(jwt.split(".")[1]));
  const now = new Date().valueOf();
  const exp = data.exp * 1000;
  return now < exp;
}

export function isAuthenticated() {
  return new Promise((resolve, reject) => {
    if (
      !localStorage.token ||
      localStorage.token == ""
    ) {
      logout();
      resolve(false);
    } else {
      var jwt = localStorage.token;
      if (!isValidJwt(jwt)) {
        var refreshJwt = localStorage.token;
        if (refreshJwt == "" || refreshJwt == null) {
          resolve(false);
        }
        auth
          .renew(refreshJwt)
          .then(result => {
            if (result) {
              localStorage.token = result.data.token;
              EventBus.$emit("Authenticated");
              resolve(true);
            } else {
              logout();
              resolve(false);
            }
          })
          .catch(reason => {
            logout();
            resolve(false);
          });
      } else {
        server.defaults.headers.common = {
          Authorization: "Bearer " + jwt,
          "Content-Type": "application/json"
        };
        resolve(true);
      }
    }
  });
}

export function logout() {
  if (localStorage.token) {
    delete localStorage.token;
  }
}
